/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjects_Subject_Biology15Inputs */

const en__field__enum_teachingsubjects_subject_biology15 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Biology15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biology`)
};

const de__field__enum_teachingsubjects_subject_biology15 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Biology15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biologie`)
};

/**
* | output |
* | --- |
* | "Biology" |
*
* @param {_Field__Enum_Teachingsubjects_Subject_Biology15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjects_subject_biology15 = /** @type {((inputs?: _Field__Enum_Teachingsubjects_Subject_Biology15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjects_Subject_Biology15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjects_subject_biology15(inputs)
	return de__field__enum_teachingsubjects_subject_biology15(inputs)
});
export { _field__enum_teachingsubjects_subject_biology15 as "_field__enum_teachingSubjects_SUBJECT_BIOLOGY" }